<template>
  <div class="custom-select-container-horizontal">
    <label v-if="label" class="custom-select-label-horizontal">{{
      label
    }}</label>

    <div class="custom-select-wrapper" @click.stop="toggleDropdown">
      <div class="custom-select-input">
        {{ selectedLabel || placeholder }}
        <img
          class="arrow-img"
          :src="dropdownOpen ? arrowGrayDownDown : arrowGrayDown"
          alt="arrow"
        />
      </div>
      <div v-if="dropdownOpen" class="custom-select-dropdown">
        <div
          v-for="(item, index) in options"
          :key="index"
          class="custom-select-item"
          @click.stop="selectItem(item)"
        >
          {{ item[labelKey] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch, onMounted, onBeforeUnmount } from "vue";
import arrowGrayDown from "@/assets/timer_gray_arraw_down.svg";
import arrowGrayDownDown from "@/assets/timer_gray_arraw_downdo.svg";

export default {
  props: {
    modelValue: [String, Number],
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    label: String,
    labelKey: {
      type: String,
      default: "label",
    },
    valueKey: {
      type: String,
      default: "value",
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const dropdownOpen = ref(false);
    const selectedLabel = ref("");

    const toggleDropdown = () => {
      dropdownOpen.value = !dropdownOpen.value;
    };

    const selectItem = (item) => {
      emit("update:modelValue", item[props.valueKey]);
      selectedLabel.value = item[props.labelKey];
      dropdownOpen.value = false;
    };

    const handleClickOutside = (e) => {
      if (!e.target.closest(".custom-select-wrapper")) {
        dropdownOpen.value = false;
      }
    };

    onMounted(() => {
      document.addEventListener("click", handleClickOutside);
    });

    onBeforeUnmount(() => {
      document.removeEventListener("click", handleClickOutside);
    });

    watch(
      () => props.modelValue,
      (val) => {
        const find = props.options.find((o) => o[props.valueKey] === val);
        selectedLabel.value = find ? find[props.labelKey] : "";
      },
      { immediate: true }
    );

    return {
      dropdownOpen,
      selectedLabel,
      toggleDropdown,
      selectItem,
      arrowGrayDown,
      arrowGrayDownDown,
    };
  },
};
</script>

<style scoped>
/* 保持之前样式不变 */
.custom-select-container-horizontal {
  display: flex;
  align-items: center;
  gap: 12px;
}
.custom-select-label-horizontal {
  font-size: 12px;
  color: #333333;
  text-align: right;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
}
.custom-select-wrapper {
  position: relative;
  min-width: 150px;
  cursor: pointer;
  font-size: 12px;
  color: #9fa1a8;
}
.custom-select-input {
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  padding: 6px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: border 0.3s;
}
.custom-select-wrapper:hover .custom-select-input {
  border-color: #8e67ea;
}
.arrow {
  font-size: 12px;
  transition: transform 0.3s;
}
.arrow.open {
  transform: rotate(180deg);
}
.custom-select-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  background-color: #fff;
  z-index: 10;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.custom-select-item {
  position: relative;
  padding: 6px 10px;
  transition: background 0.2s;
  color: #000000;
  font-size: 12px;
  height: 30px;
  display: flex;
  align-items: center;
}

.custom-select-item::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 10px; /* 与 padding 左边保持一致 */
  right: 10px; /* 与 padding 右边保持一致 */
  height: 1px;
  background-color: #e5e5e5;
}

.custom-select-item:last-child::after {
  display: none; /* 最后一个不显示分割线 */
}
/* 去掉最后一条分割线 */
.custom-select-item:last-child {
  border-bottom: none;
}
.custom-select-item:hover {
  background-color: #f5f5f5;
}
</style>
